module.exports = __webpack_public_path__ + "static/media/accountImg.818b98a7.svg";